import slotTimetableConverter from 'models/SlotTimetable/converter'
import getCollectionByName from 'actions/base/getCollectionByName'

const getCollection = (withConverter = true) =>
  getCollectionByName('slotTimetables', withConverter ? slotTimetableConverter : null)

export default getCollection
